import React from "react";
import { Outlet } from "react-router-dom";
import Button from "../../components/FormComponents/Button";
import { useAuth0Context } from "../../context/Auth0Context";

const RoleGuard = ({ allowedRoles, children }) => {
  const { user } = useAuth0Context();
  const userRoles = user?.role_names || [];

  // Check Allowed Roles (Allow List)
  if (allowedRoles && allowedRoles.length > 0) {
    const hasAccess = userRoles.some((role) => allowedRoles.includes(role));
    if (!hasAccess) {
      return <AccessDenied />;
    }
  }

  return children ? children : <Outlet />;
};

const AccessDenied = () => (
  <div className="w_100_vw h_100_vh d_flex justify_center align_center">
    <div className="d_flex flex_column align_center gap_2 justify_center">
      <div>You Don't have permission to access this page.</div>
      <Button onClick={() => (window.location.href = "/organization")}>Back To Organization</Button>
    </div>
  </div>
);

export default RoleGuard;
